<template>
	<div class="home">
		<div class="home-wrap">
			<div class="home-content">
				<ul class="home-list">
					<li>
						<div class="home-list-item">
							<div class="home-list-item-title">平台订单量</div>
							<div class="home-list-item-num stC1" ><span>{{businessList.waybillTotalQuantity}}</span>单</div>
						</div>
					</li>
					<li>
						<div class="home-list-item">
							<div class="home-list-item-title">注册货主数量</div>
							<div class="home-list-item-num  stC2"><span>{{businessList.ownerQuantity}}</span>人</div>
						</div>
					</li>
					<li>
						<div class="home-list-item">
							
							<div class="home-list-item-title">注册司机数量</div>
							<div class="home-list-item-num  stC2"><span>{{businessList.driverQuantity}}</span>人</div>
						</div>
					</li>
					<li>
						<div class="home-list-item">
						<div class="home-list-item-title" style="padding-bottom: 40px;">
							取消社会订单 
							<span class="stC3" ><span style="font-weight: bolder;">{{businessList.cancelCommonWayill}}</span> 单 </span>
						 </div>
						<div class="home-list-item-title" style="padding-bottom: 0px;">
							取消物流拼单 
							<span class="stC4"><span style="font-weight: bolder;">{{businessList.cancelCollageToWyabill}}</span> 单</span>
						</div>
						</div>
					</li>
				</ul>
				<ul class="home-list2">
					<li>
						<div class="home-list-item">
							
							<div class="home-list-item-title">待接单订单</div>
							<div class="home-list-item-num  stC3"><span>{{businessList.waybillUnprocessedQuantity}}</span>单</div>
						</div>
					</li>
					<li>
						<div class="home-list-item">
							<div class="home-list-item-title">物流订单</div>
							<div class="home-list-item-num  stC3"><span>{{businessList.waybillFranchiseQuantity}}</span>单</div>
							
						</div>
					</li>
					<li>
						<div class="home-list-item">
							<div class="home-list-item-title" style="padding-bottom: 40px;">
								社会订单 
								<span class="stC3" ><span style="font-weight: bolder;">{{businessList.commonWaybill}}</span> 单 </span>
							 </div>
							<div class="home-list-item-title" style="padding-bottom: 0px;">
								物流拼单 
								<span class="stC4"><span style="font-weight: bolder;">{{businessList.collageToWyabill}}</span> 单</span>
							</div>
						</div>
					</li>
					<li>
						<div class="home-list-item">
							<div class="home-list-item-title" style="line-height:25px;padding-bottom: 15px;">平台普通单=</br>社会订单+物流拼单</div>
							<div class="home-list-item-num  stC2"><span>{{businessList.commonWaybill + businessList.collageToWyabill}}</span>单</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="home-myChart">
				<div class="home-myChart-title tc">走势图（{{startMonth}} 至 {{endMonth}}）</div>
				<div id="myChart">
				</div>
			</div>
		</div>
		<st-dialog title="消息提示" :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false"
			@saveDialog="toggleStDialog=false" defindBtnText="确定">
			<div class="st-dialog-content">
				<div>有新订单啦</div>
			</div>
		</st-dialog>
	</div>
</template>
<script>
import echarts from 'echarts'
import stDialog from '../../src/components/StDialog'
export default {
	name: 'Home',
	props: [],
	components: {stDialog},
	data(){
		return{
			toggleStDialog:false,
			businessList:{},
			Xdate:null,
			Ydata:null,
			startMonth:null,
			endMonth:null,
		}
	},
	computed:{
		
	},
	created() {},
	methods: {
		getChart(data){
			let Xdate=[];
			let Ydata=[];
			this.$server.report.waybillStatisticsPage(data,(res)=>{
				if(res.code==0){
					res.data.records.forEach(item=>{
						Xdate.push(item.dateMonthFormatted)
						Ydata.push(item.volume)
					})
					this.Xdate=Xdate.reverse();
					this.Ydata=Ydata.reverse();
					this.startMonth=Xdate[0]
					this.endMonth=Xdate[Xdate.length-1];
					this.drawLine();
				}
			})
		},
		drawLine(){
       	 	// 基于准备好的dom，初始化echarts实例
			let myChart = this.$echarts.init(document.getElementById('myChart'));
			let xAxisData=this.Xdate;
			let seriesData=this.Ydata;
			let option = {
				xAxis: {
					type: 'category',
					data: xAxisData
				},
				yAxis: {
					type: 'value'
				},
				series: [{
					data: seriesData,
					type: 'line'
				}]
			};
			myChart.setOption(option)
		},
		getBusiness(){
			this.$server.business.business((res)=>{
				this.businessList=res.data;
			})
		},
	},
	mounted() {
		this.getChart()
		this.getBusiness();
	}
}

</script>
<style scoped >
.home{
	position:absolute;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	background-color: #fff;
	overflow: auto;
}
.home-wrap{
	
}
#myChart{
	width: 100%;
	height: 300px;
}
/* .home-content{
	display: flex;
	justify-content: center;
	
} */
.home-list{
	width: 1000px;
	display: flex;
	margin:  10px auto;
	flex-wrap:wrap;
	justify-content: space-around;
	
}
.home-list2{
	width: 1000px;
	margin:  10px auto;
	display: flex;
	flex-wrap:wrap;
	justify-content: space-around;	
	
}
.home-list li{
	width: 200px;
	height: 200px;
	border: 1px solid #DCDCDC;
	border-radius: 50%;
	
	box-sizing: border-box;
	display: flex;
	justify-items: center;
	
	align-items: center;
}
.home-list2 li{
	width: 200px;
	height: 200px;
	border: 1px solid #DCDCDC;
	border-radius: 50%;
	/* margin: 10px 25px; */
	box-sizing: border-box;
	display: flex;
	justify-items: center;
	align-items: center;
}
.home-list li .home-list-item{
	text-align: center;
	width: 100%;

}
.home-list2 li .home-list-item{
	text-align: center;
	width: 100%;

}
.home-list-item-title{
	padding-bottom: 30px;
}
.stC1{
	color: rgb(51, 204, 0)
}
.stC2{
	color: rgb(255, 0, 0)
}

.stC3{
	color: rgb(255, 102, 0)
}

.stC4{
	color: blue
}
.home-list-item-num span{
	font-weight: bolder;
}
.home-myChart-title{
	font-size: 20px;
	line-height: 50px;
	font-weight: bold;
}
.st-dialog-content{
	height: 104px;
	text-align: center;
	padding: 20px 0;
}
@media only screen and (max-width: 1366px) {
	/* .home-list li{
		width: 130px;
		height: 130px;
		margin: 15px 70px;
	} */
	#myChart {
		width: 80%;
		height: 270px;
		margin: 0 auto;
	}
}
</style>
